import React, { useState, useMemo, useRef, useEffect } from "react";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-enterprise';
/*import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { RangeSelectionModule } from "@ag-grid-enterprise/range-selection";
import { MenuModule } from '@ag-grid-enterprise/menu';
import { FiltersToolPanelModule } from '@ag-grid-enterprise/filter-tool-panel';
import { ColumnsToolPanelModule } from '@ag-grid-enterprise/column-tool-panel';
import { SetFilterModule } from '@ag-grid-enterprise/set-filter';*/
// import "@ag-grid-community/core/dist/styles/ag-grid.css";
// import "@ag-grid-community/core/dist/styles/ag-theme-alpine.css";
//import { RangeSelectionModule } from "@ag-grid-enterprise/range-selection";
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
// import { Row, Col } from "reactstrap";
import './pgrid.scss';
import UpdAct from "./pupd";
import DelAct from "./del";
import CopyAct from "./copy";
import FavIcn from "./fav";
import { useSelector, useDispatch } from "react-redux";
import { showUpdProj, showCopyProj, showTags, showLoader, showPkgsAct } from '../redux/ctrl/ctrlActions';
import { fetchPkgAct, fetchTagsAct, fPkgsAct, updateProjectAct, clearQuoteSearch } from "../redux/project/projActions";
import { fetchUserPreferenceAct } from "../redux/profile/profileActions";
import ProjSel from './projSel';
import CopyProject from '../createProject/copyProject';
import Loader from '../loader';
// import { useHistory } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import getDt, { dateComparator, numberComparator, getDtfrmt, statusBar } from "../../utils";
import { onGetPkgs } from "../redux/project/projSaga";
import CustomTooltip from './customTooltip';
import { BsStar, BsStarFill } from "react-icons/bs";
import { Grid, LinearProgress } from "@mui/material";
import { agGridTrans } from "../translation/i18n";
import { useTranslation } from 'react-i18next';
import { getProjectColumnFields } from './projectColumnDefs';

//import { setView,hideLoader } from '../redux/ctrl/ctrlActions';
export const ProjGrid = (props) => {
  // let history = useHistory();
  let navigate = useNavigate()
  const gridRef = useRef();
  const isRestoringFilter = useRef(false);
  const proj = useSelector((state) => state.crtl);
  const projStat = useSelector((state) => state.ctrl.projStatus)
  const eProj = { ...proj }
  const [uProj, setProj] = useState(eProj);
  const [gridApi, setGridApi] = useState(null);
  const [gridColumnApi, setGridColumnApi] = useState(null);
  const dispatch = useDispatch();
  //const newTheme = { ...proj };
  const srch = localStorage.getItem('NR') || [].includes('NR') ? true : false;

  const [refresh, setRefresh] = useState(false);
  const sctrl = useSelector((state) => state.ctrl)
  const [isFav, setFav] = useState(sctrl.data.favorite === 'Y' ? true : false);
  const projects = useSelector((state) => state.project.projects);

  const [proCur, SetproCur] = useState([]);
  const [newCopy, SetnewCopy] = useState(null);
  const [newCopyindex, SetnewCopyindex] = useState(null);
  const [fetchtagPBarCount, setFetchtagPBarCount] = useState(0);
  const destroyed = useSelector((state) => state.ctrl.destroyedGrid);
  const quoteSearchResults = useSelector((state) => state.project.quoteSearchResults);
  const { t, i18n } = useTranslation();

  const profileState = useSelector((state) => state.profile);
  const isFavDisable = profileState.capb.findIndex((o) => o.PWSFAVPRJ === 'Y') >= 0 ? false : true;
  const isCopyCapb = profileState?.capb?.findIndex((o) => o.PWSCPPRJ === 'Y') >= 0 ? true : false
  const userPreference = useSelector((state) => state.profile.userPreference);
  const preferenceLoading = useSelector((state) => state.profile.preferenceLoading);
  useEffect(() => {
    if (proCur.length === 0) {
      SetproCur(projects);
    }
    if (proCur && proCur.length > 0 && proCur.length != projects.length) {
      let newPrj = {};
      function projExists(project_ws_id) {
        return proCur.some(function (el) {
          return el.project_ws_id === project_ws_id;
        });
      }

      projects.map((newdata) => {
        let checkExists = projExists(newdata.project_ws_id);
        if (!checkExists) {
          newPrj = newdata;
        }
      })

      const getIndex = props.data.findIndex(x => x.project_ws_id === newPrj.project_ws_id);
      SetnewCopyindex(getIndex);
      SetnewCopy(newPrj);
      SetproCur(projects);
    }
  }, [projects]);

  useEffect(() => {
    if (srch) {
      setRefresh(true)
      localStorage.removeItem('NR')
    }
  }, [srch])

  useEffect(
    () => {
      setFav(sctrl.data.favorite === ("Y") ? true : false);
    }, [sctrl.data]
  )

  useEffect(() => {
    if (profileState.email) {
      dispatch(fetchUserPreferenceAct({ email: profileState.email, type: 'project' }));
    }
  }, []);
  useEffect(() => {
    const handleClearFilters = () => {
      if (gridApi) {
        gridApi.setFilterModel(null);
        localStorage.removeItem('pgrid_filterModel');
      }
    };
    window.addEventListener('pgrid-clear-filters', handleClearFilters);
    return () => window.removeEventListener('pgrid-clear-filters', handleClearFilters);
  }, [gridApi]);

  const getcrDtf = (params) => {
    let val = getDtfrmt(params.data.start_date)
    return val.replace('--', '-')
  }

  const getDtf = (params) => {
    let val = getDtfrmt(params.data.last_mod_date)
    return val.replace('--', '-')
  }

  const onGridReady = (params) => {
    setGridApi(params.api);
    setGridColumnApi(params.columnApi);
    params.api.sizeColumnsToFit(false);

    // Restore saved filter model from localStorage
    const savedFilterModel = localStorage.getItem('pgrid_filterModel');
    if (savedFilterModel) {
      try {
        isRestoringFilter.current = true;
        const parsed = JSON.parse(savedFilterModel);
        const validFilter = {};
        Object.keys(parsed).forEach(colId => {
          if (params.columnApi.getColumn(colId)) validFilter[colId] = parsed[colId];
        });
        if (Object.keys(validFilter).length > 0) {
          params.api.setFilterModel(validFilter);
        }
      } catch (e) {
        console.error('Error restoring pgrid filter model:', e);
        localStorage.removeItem('pgrid_filterModel');
      } finally {
        isRestoringFilter.current = false;
      }
    }

    params.api.forEachNode((node) => {
      if (refresh) {
        node.setSelected(node.data.project_ws_id === newCopy.project_ws_id)
        params.api.ensureIndexVisible(newCopyindex - 1 || 0, 'middle');
        setRefresh(false);
        SetnewCopy(null);
      }
    }
    )
  };


  const defaultColDef = useMemo(() => {
    return {
      flex: 1,
      sortable: true,
      resizable: true,
      filter: true,
      minWidth: 100,
      field: 'project_name',
      comparator: function (valueA, valueB, nodeA, nodeB, isDescending) {
        return (valueA == valueB) ? 0 : (valueA > valueB) ? 1 : -1;
      },
      sortingOrder: ["asc", "desc", ""],
      filterParams: {
        // excelMode: 'windows',
        buttons: ['apply', 'cancel'],
        closeOnApply: true,
        tooltipComponent: CustomTooltip,
      },
      multiSortKey: 'ctrl',
      resizable: true,
      menuTabs: ['filterMenuTab', 'generalMenuTab', 'columnsMenuTab'],
      tooltipComponent: CustomTooltip,
    };
  }, []);

  const getStatusDesc = (params) => {
    return projStat.find(val => val.value === params.data.project_status)?.label
  }

  const customComparator = (valueA, valueB) => {
    // return valueA.toLowerCase().localeCompare(valueB.toLowerCase());
    return valueA.toLowerCase().localeCompare(valueB.toLowerCase(), undefined, { numeric: true, sensitivity: 'base' });
  };

  //   const sortComparer = (reference, comparer) => {
  //     if (reference < comparer) {
  //         return -1;
  //     }
  //     if (reference > comparer) {
  //         return 1;
  //     }
  //     return 0;
  // };

  // const customComparator1 = (valueA, valueB, nodeA, nodeB, isDescending) => {
  //   let val1 = +valueA;
  //   let val2 = +valueB;
  //   if(typeof val1 === "number" && typeof val2 === "number") return val1 - val2;
  // }

  // Get column field mappings from external file and apply user preferences
  const columnFields = useMemo(() => {
    if (preferenceLoading) return [];
    const baseColumns = getProjectColumnFields(t).map(col => ({
      headerName: col.headerName,
      field: col.column_name
    }));

    // Checkbox column - always visible and pinned to the left
    const checkboxColumn = { headerName: "", field: 'selection', width: 50, maxWidth: 50, filter: false, resizable: false, checkboxSelection: true, headerCheckboxSelectionFilteredOnly: true, headerCheckboxSelection: true, pinned: 'left', lockPosition: true, suppressMenu: true, suppressColumnsToolPanel: true };

    const allCols = [
      {
        ...baseColumns[0], width: 250, filter: true, resizable: true, minWidth: 250,
        comparator: customComparator,
        tooltipComponentParams: { text: t('Click to Navigate to Packages'), field: '1' },
        tooltipField: 'project_name',
        cellRenderer: ProjSel,
      },
      {
        ...baseColumns[1], width: 220, filter: true, minWidth: 220, comparator: numberComparator,
        cellRenderer: ProjSel,
        tooltipComponentParams: { text: t('Click to edit the project'), field: '2' },
        tooltipField: 'project_name'
      },
      {
        ...baseColumns[2], width: 58, headerClass: "copyHeaderCell", minWidth: 58, resizable: false,
        cellRenderer: CopyAct,
        cellRendererParams: (params) => ({ isDisabled: !isCopyCapb || params.data.writecol !== "Y" }),
        ...(isCopyCapb && {
          tooltipComponentParams: (params) => ({
            text: t('Click to copy the existing project'),
            field: '3',
            isDisabled: !isCopyCapb || params.data.writecol !== "Y"
          }),
          tooltipField: 'project_name'
        })
      },
      {
        ...baseColumns[3], width: 80, headerClass: "FavHeaderCell", resizable: false, minWidth: 80,
        cellRenderer: FavIcn,
        cellRendererParams: (params) => ({ isDisabled: isFavDisable || params.data.writecol !== "Y" })
      },
      { ...baseColumns[4], width: 100, filter: true, resizable: true, minWidth: 100, valueGetter: getStatusDesc },
      { ...baseColumns[5], width: 200, filter: true, resizable: true, minWidth: 200 },
      { ...baseColumns[6], width: 200, filter: true, resizable: true, minWidth: 200 },
      { ...baseColumns[7], width: 200, filter: true, resizable: true, minWidth: 150 },
      { ...baseColumns[8], comparator: dateComparator, width: 200, filter: true, resizable: true, minWidth: 150, valueGetter: getcrDtf },
      { ...baseColumns[9], comparator: dateComparator, width: 170, filter: true, resizable: true, minWidth: 170, valueGetter: getDtf },
      { ...baseColumns[10], width: 250, filter: true, resizable: true, minWidth: 250 },
    ];

    if (!userPreference?.columns?.length || userPreference.preference_key !== 'project') {
      return [checkboxColumn, ...allCols];
    }

    // Single iteration to create map and find max order
    let maxPrefOrder = 0;
    const prefMap = new Map();
    for (const pref of userPreference.columns) {
      prefMap.set(pref.column_name, pref);
      const order = pref.column_order || 0;
      if (order > maxPrefOrder) maxPrefOrder = order;
    }

    let nextOrder = maxPrefOrder + 1;

    // Apply preferences to all columns except checkbox, sort, and remove column_order
    const processedCols = allCols
      .map(col => {
        const pref = prefMap.get(col.field);
        return pref
          ? { ...col, hide: !pref.is_visible, column_order: pref.column_order }
          : { ...col, hide: true, column_order: nextOrder++ };
      })
      .sort((a, b) => (a.column_order || 999) - (b.column_order || 999))
      .map(({ column_order, ...col }) => col);

    // Always prepend checkbox column at the beginning
    return [checkboxColumn, ...processedCols];
  }, [t, userPreference, isFavDisable, isCopyCapb, preferenceLoading]);

  // console.log("columnFields",  columnFields)

  let gridDefinition = {
    columnDefs: columnFields,


    defaultColDef: {
      sortable: true,
      resizable: true,
      filter: true,
      sortingOrder: ["asc", "desc"],
      filterParams: {
        // excelMode: 'windows',
        buttons: ['apply', 'cancel'],
        closeOnApply: true,
        tooltipComponent: CustomTooltip,
      },
      menuTabs: ['filterMenuTab', 'generalMenuTab', 'columnsMenuTab'],
    },
    rowClassRules: {
      'projectgrid-alternaterows': function (data) { return (data.node.rowIndex % 2 === 1) }
    }
  }

  //const containerStyle = useMemo(() => ({ width: '100%', height: '10%' }), []);

  const updateProjct = (updPrj) => {

    dispatch(showLoader(true));

    dispatch(updateProjectAct(updPrj));
    dispatch(showLoader(false));
    //setTimeout(()=> {dispatch(updateProjectAct(updPrj))},500)
  }


  const onClickCell = (e) => {
    //  console.log({e});
    const newData = { ...e }
    if (!isFavDisable && e.data.writecol == "Y" && e.colDef.field === "favorite") {
      var currentdate = new Date();
      sctrl.data.last_mod_date = getDt(currentdate);
      if (newData?.data?.favorite === 'Y') {
        newData.data.favorite = 'N';
      } else {
        newData.data.favorite = 'Y'
      }
      const updPrj = {
        project_id: e.data.project_id,
        project_ws_id: e.data.project_ws_id,
        project_name: e.data.project_name,
        project_number: e.data.project_number,
        owner_name: e.data.owner_name,
        project_status: e.data.project_status,
        lead_project_engineer: e.data.lead_project_engineer,
        lead_project_manager: e.data.lead_project_manager,
        world_area: e.data.world_area,
        pdl_project_name: e.data.pdl_project_name,
        project_bg_info: e.data.project_bg_info,
        last_updatedby: e.data.last_updatedby,
        start_date: getDt(new Date(e.data.start_date)),
        last_mod_date: getDt(new Date(e.data.last_mod_date)),
        created_by: e.data.created_by,
        favorite: newData.data.favorite,
        search: 'email'
      }
      updateProjct(updPrj)
    }
    if (e.colDef.field === "project_number") {
      eProj.updProj = true;
      eProj.data = newData.data;
      eProj.due_date = new Date(e.data.due_date)
      eProj.last_mod_date = new Date(e.data.last_mod_date)
      setProj(eProj)
      dispatch(showUpdProj(eProj))
    }
    else if (e.colDef.field === "Copy" && isCopyCapb && e.data.writecol == "Y") {
      eProj.copyProj = true;
      eProj.data = newData.data;
      setProj(eProj)
      dispatch(showCopyProj(eProj));
    }
    else if (e.colDef.field === "project_name") {
      eProj.showPkgs = true;
      eProj.data = newData.data;
      setProj(eProj)
      dispatch(showPkgsAct(eProj))
      dispatch(showLoader(true))
      // history.push('/pkgs')    
      let payLd = (e.data.package_id != null && e.data.package_id != "") ? `pid=${e.data.project_id}&pkgid=${e.data.package_id}` : `pid=${e.data.project_id}`;
      dispatch(fPkgsAct(payLd))
      //  Quote Search - if project is created from quote then navigate to pkgs with quote number
      let url = '/pkgs'
      if (quoteSearchResults?.package) {
        const queryParams = new URLSearchParams();
        if (props.advanceSearchFields.package_name) {
          queryParams.append('package_name', props.advanceSearchFields.package_name);
        }
        if (props.advanceSearchFields.quote_number) {
          queryParams.append('quote_number', props.advanceSearchFields.quote_number);
        }
        const query = queryParams.toString() ? `?${queryParams.toString()}` : '';
        url = `/pkgs${query}`
        dispatch(clearQuoteSearch())
      }
      navigate(url)
      //dispatch(fPkgsAct({pid:e.project_id}))
      //dispatch(fetchTagsAct({aid:e.data.project_id}))

    }
  }
  const allProjectData = useSelector((state) => state.project.projects)
  const [totalProject, setTotalProject] = useState(0);


  useEffect(() => {
    // if (profileState.capb.findIndex((o)=>o.PWSALPRJ === 'Y') >= 0){
    // let tempObjKey = [profileState.appAcc[0].business_unit,projects.length];
    let tempObjKey = [profileState.appAcc[0].business_unit, profileState.appAcc[0].bu_proj_count];

    // console.log("Profile State:3751223", profileState.appAcc[0].business_unit);
    //console.log("Projects count", projects.length);
    //console.log("Temp Object Key:377", tempObjKey);
    let convertedObject = {
      [tempObjKey[0]]: tempObjKey[1]
    }
    let allBUObj = { ...profileState.appAcc[0].secondary_office_count, ...convertedObject };
    // console.log("All BU Object:378", allBUObj);
    setTotalProject(allBUObj[profileState.bu]);
    //console.log("Total Projects:379", totalProject);
    // }else {
    //     setTotalProject(profileState.appAcc[0].project_count);
    // }
  }, [profileState.capb, profileState.bu])

  // useEffect (()=>{
  //   console.log("All Projects Data:", allProjectData.length);
  //   console.log("Total Projects:", totalProject);
  //     let per = Math.round (allProjectData?.length * 100 / (totalProject))
  //     setFetchtagPBarCount(per)
  // },[allProjectData,totalProject])
  useEffect(() => {
    // console.log("Updated All Projects Data:", allProjectData);
    // console.log("Updated Total Projects:", totalProject);

    const projectCount = allProjectData.length;
    const total = totalProject;

    if (total === 0) {
      setFetchtagPBarCount(0);
      return;
    }

    let per = Math.round((projectCount * 100) / total);
    per = Math.min(per, 100);
    setFetchtagPBarCount(per);
  }, [allProjectData, totalProject]);

  const projData = useSelector((state) => {
    const projectData = state.project.projects;
    return projectData;
  })
  //console.log("projectcount -- total project -- percentage", projData.length,totalProject,fetchtagPBarCount)
  return (
    <>
      {/* <CopyProject /> */}
      {/* <Loader />  */}
      {!srch && <div className="locag" >
        <Grid container>
          <Grid item style={{ height: "8rem", width: "150%" }}  >
            {
              (profileState.capb.findIndex((o) => o.PWSALPRJ === 'Y') >= 0) &&
              <>
                {projData.length > 0 && (projData.length != totalProject) && fetchtagPBarCount !== 100 &&
                  <div sm={12} md={12} lg={12}>
                    <LinearProgress variant='determinate' value={fetchtagPBarCount || 0} style={{ marginLeft: "-5px" }} />
                  </div>
                }
              </>
            }
            <div id="inputgrid"  /*style={{height:"28rem", width:"110%"}} */ className="ag-theme-alpine projG">
              {!destroyed && <AgGridReact
                /*modules={[
                    ClientSideRowModelModule,
                    MenuModule,
                    FiltersToolPanelModule,
                    ColumnsToolPanelModule,
                    SetFilterModule,
                        ]}*/
                headerHeight={30}
                statusBar={statusBar}
                rowData={props.data}
                localeText={agGridTrans[localStorage.getItem("lang")]}
                //  immutableData={true}
                columnDefs={gridDefinition.columnDefs}
                //defaultColDef={gridDefinition.defaultColDef}
                defaultColDef={defaultColDef}
                //getRowHeight={35}
                enableRangeSelection={true}
                reactNext={true}
                animateRows={true}
                rowHeight={25}
                onGridReady={(params) => onGridReady(params)}
                onFilterChanged={(e) => {
                  if (isRestoringFilter.current) return;
                  if (props.advanceSearchFields && Object.keys(props.advanceSearchFields).length > 0) return;
                  const filterModel = e.api.getFilterModel();
                  if (filterModel && Object.keys(filterModel).length > 0) {
                    localStorage.setItem('pgrid_filterModel', JSON.stringify(filterModel));
                  } else {
                    localStorage.removeItem('pgrid_filterModel');
                  }
                }}
                onRowDataUpdated={(e) => {
                  const savedFilter = localStorage.getItem('pgrid_filterModel');
                  if (savedFilter) {
                    try {
                      isRestoringFilter.current = true;
                      const parsed = JSON.parse(savedFilter);
                      const validFilter = {};
                      Object.keys(parsed).forEach(colId => {
                        if (e.columnApi.getColumn(colId)) validFilter[colId] = parsed[colId];
                      });
                      if (Object.keys(validFilter).length > 0) {
                        e.api.setFilterModel(validFilter);
                      }
                    } catch (err) {
                      console.error('Error restoring pgrid filter on data update:', err);
                      localStorage.removeItem('pgrid_filterModel');
                    } finally {
                      isRestoringFilter.current = false;
                    }
                  }
                }}
                rowSelection={"single"}
                suppressCopyRowsToClipboard={true}
                //pagination={true}
                //paginationPageSize={15}
                //domLayout={'autoHeight'} 
                //getRowNodeId={data => data.project_id}               
                getRowId={ele => ele.data.project_id}
                ref={gridRef}
                //frameworkComponents= {{updact: UpdAct,projNo: ProjNo,copyact:CopyAct/*,delact:DelAct*/}} 
                onCellClicked={(e) => onClickCell(e)}
                // onCellDoubleClicked={(e) =>onCellDoubleClicked(e)}
                tooltipShowDelay={0}
                tooltipMouseTrack={true}
              >
                {/*<AgGridColumn headerName= 'project_id' field= 'project_id' width= {100}  filter={false} hide={true} suppressMenu={true} suppressColumnsToolPanel={true} />                                                            
                    <AgGridColumn headerName= 'Project Name' field= 'project_name' width= {200} filter={true} resizable ={true} minWidth={200} checkboxSelection ={true} minWidth={200}/>                    
                    <AgGridColumn headerName= 'Project No' field= 'project_number' width= {200} filter={true} resizable ={true}  minWidth={170}  />                                        
                    <AgGridColumn headerName= 'Master?' field= 'master_prj' width= {90} filter={false}  suppressColumnsToolPanel={true} suppressMenu={true} resizable={false} minWidth={90}/>
                    <AgGridColumn headerName= 'Actions' field= 'update' width= {40} filter={false}  cellRenderer="updact" suppressColumnsToolPanel={true} suppressMenu={true} resizable={false} minWidth={50} type ={'leftAligned'} />                        
                    <AgGridColumn headerName= 'Epc' field= 'epc'  width= {200}  filter={false} resizable ={true} minWidth={200}/>
                    <AgGridColumn headerName= 'End Customer' field= 'endcust_prjref' width= {350} filter={false} minWidth={200}/>
                    <AgGridColumn headerName= 'Status' field= 'project_status' width= {250} filter={true} minWidth={160}/>
                    <AgGridColumn headerName= 'Project Manager' field= 'project_manager' width= {350} filter={false} minWidth={200}/>    
                    <AgGridColumn headerName= 'Project Engineer' field= 'project_engineer' width= {350} filter={false} minWidth={200} />    
                    <AgGridColumn headerName= 'Created By' field= 'created_by' width= {120}  filter={false} hide={true} />
                    <AgGridColumn headerName= 'Last Modified' field= 'last_mod_date' width= {400}  filter={false}  />
                    <AgGridColumn headerName= 'Delete' field= 'delete' width= {100} filter={false}  cellRenderer="delact"/>    
                    <AgGridColumn headerName= 'Master Project' field= 'master_project' width= {220} minWidth={200} filter={false}/>*/}
                {/*<AgGridColumn headerName= 'Parent Project' field= 'parent_project' width= {220} minWidth={200} filter={false}/>*/}
              </AgGridReact>}
            </div>
          </Grid>
        </Grid>
        <br />
      </div>
      }
    </>
  )
}

export default ProjGrid;